import { Routes } from '@angular/router';

import { AuthGuard } from './guards/auth.guard';
import { AdministratorGuard } from './guards/administrator.guard';
import { LandingGuard } from './guards/landing.guard';
import { MobileGuard } from './guards/mobile.guard';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    canActivate: [AuthGuard, LandingGuard],
    loadComponent: () =>
      import('./overview/overview.component').then((m) => m.OverviewComponent),
  },
  {
    path: 'users',
    canActivate: [AuthGuard, AdministratorGuard],
    loadComponent: () =>
      import('./users/list/list.component').then((m) => m.UsersListComponent),
  },
  {
    path: 'devices',
    canActivate: [AuthGuard, AdministratorGuard],
    loadComponent: () =>
      import('./devices/list/list.component').then((m) => m.DevicesListComponent),
  },
  {
    path: 'device',
    canActivate: [AuthGuard, AdministratorGuard],
    loadComponent: () =>
      import('./devices/details/details.component').then((m) => m.DeviceDetailsComponent),
  },
  {
    path: 'settings',
    canActivate: [AuthGuard, AdministratorGuard],
    loadComponent: () =>
      import('./settings/settings.component').then((m) => m.SettingsComponent),
  },
  {
    path: 'overview',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./overview/overview.component').then((m) => m.OverviewComponent),
  },
  {
    path: 'overview/:user',
    canActivate: [AuthGuard, AdministratorGuard],
    loadComponent: () =>
      import('./overview/overview.component').then((m) => m.OverviewComponent),
  },
  {
    path: 'working-year',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./working-year/working-year.component').then((m) => m.WorkingYearComponent),
  },
  {
    path: 'dashboard',
    canActivate: [AuthGuard, AdministratorGuard],
    loadComponent: () =>
      import('./dashboard/dashboard.component').then((m) => m.DashboardComponent),
  },
  {
    path: 'working-month',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./working-month/working-month.component').then((m) => m.WorkingMonthComponent),
  },
  {
    path: 'working-month/:month/:year',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./working-month/working-month.component').then((m) => m.WorkingMonthComponent),
  },
  {
    path: 'working-day',
    canActivate: [AuthGuard],
    loadChildren: () =>
      import('./working-day/working-day.routes').then((m) => m.WORKING_DAY_ROUTES),
  },
  {
    path: 'user',
    canActivate: [AuthGuard, AdministratorGuard],
    loadComponent: () =>
      import('./users/details/details.component').then((m) => m.UserDetailsComponent),
  },
  {
    path: 'user/:user',
    canActivate: [AuthGuard, AdministratorGuard],
    loadComponent: () =>
      import('./users/details/details.component').then((m) => m.UserDetailsComponent),
  },
  {
    path: 'working-hours-overview',
    canActivate: [AuthGuard, AdministratorGuard],
    loadComponent: () =>
      import('./working-hours-overview/working-hours-overview.component').then((m) => m.WorkingHoursOverviewComponent),
  },
  {
    path: 'working-hours-overview/:month/:year',
    canActivate: [AuthGuard, AdministratorGuard],
    loadComponent: () =>
      import('./working-hours-overview/working-hours-overview.component').then((m) => m.WorkingHoursOverviewComponent),
  },
  {
    path: 'leave-requests/apply',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./leave-requests/apply/leave-request-apply.component').then((m) => m.LeaveRequestApplyComponent),
  },
  {
    path: 'leave-requests/pending',
    canActivate: [AuthGuard],
    loadComponent: () =>
      import('./leave-requests/pending/leave-requests-pending.component').then((m) => m.LeaveRequestsPendingComponent),
  },
  {
    path: 'holidays',
    canActivate: [AuthGuard, AdministratorGuard],
    loadComponent: () =>
      import('./holidays/holidays.component').then((m) => m.HolidaysComponent),
  },
  {
    path: 'holidays/:year',
    canActivate: [AuthGuard, AdministratorGuard],
    loadComponent: () =>
      import('./holidays/holidays.component').then((m) => m.HolidaysComponent),
  },
  {
    path: 'working-time-rule-sets',
    canActivate: [AuthGuard, AdministratorGuard],
    loadComponent: () =>
      import('./working-time-rule-sets/list/list.component').then((m) => m.WorkingTimeRuleSetsListComponent),
  },
  {
    path: 'working-time-rule-set/:id',
    canActivate: [AuthGuard, AdministratorGuard],
    loadComponent: () =>
      import('./working-time-rule-sets/details/details.component').then((m) => m.WorkingTimeRuleSetsDetailsComponent),
  },
  {
    path: 'working-time-rule-set/:id',
    canActivate: [AuthGuard, AdministratorGuard],
    loadComponent: () =>
      import('./working-time-rule-sets/list/list.component').then((m) => m.WorkingTimeRuleSetsListComponent),
  },
  {
    path: 'mobile',
    canActivate: [AuthGuard, MobileGuard],
    loadChildren: () =>
      import('./mobile/mobile.routes').then((m) => m.MOBILE_ROUTES),
  },
  {
    path: 'timeout',
    loadComponent: () =>
      import('./timeout/timeout.component').then((m) => m.TimeoutComponent),
  },
  {
    path: 'login',
    loadComponent: () =>
      import('./login/login.component').then((m) => m.LoginComponent),
  },
  {
    path: 'change-password',
    loadComponent: () =>
      import('./users/change-password/change-password.component').then((m) => m.ChangePasswordComponent),
  },
];
